
export const apiUrl = "https://api.ziz.ziz.co.ke/api"
export const socketsApiUrl = "wss://api.ziz.ziz.co.ke"
